import axios from "axios";
import {
  signedDelete,
  signedPost,
} from "./signedRequest";

const API = process.env.REACT_APP_BACKEND_URL || "";

export async function createStory({
  kind,
  textContent = null,
  objectKey = null,
  caption,
  highlighted = false
}) {
  const r = await signedPost("/api/v1/stories/me", {
    kind,
    textContent,
    objectKey,
    caption,
    highlighted,
  });

  return r.data?.story || r.data;
}

export async function fetchActiveStories() {
  const r = await axios.get(
    `${API}/api/v1/stories/active`
  );

  return Array.isArray(r.data?.items)
    ? r.data.items
    : [];
}

export async function fetchStoriesByIdentity(identityId) {
  const r = await axios.get(
    `${API}/api/v1/stories/${encodeURIComponent(identityId)}`
  );

  return Array.isArray(r.data?.items)
    ? r.data.items
    : [];
}

export async function deleteStory(storyId) {
  const r = await signedDelete(
    `/api/v1/stories/me/${encodeURIComponent(storyId)}`
  );

  return r.data;
}
